var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.type == 'LOCATION')?_c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"ml",domProps:{"innerHTML":_vm._s(_vm.htmlText)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }